import { useState } from 'react';
import useRestApiClient from 'src/hooks/useRestApiClient';

const useUserLog = () => {
  const [userLogs, setUserLogs] = useState(null);
  const [userLastLog, setUserLastLog] = useState(null);
  const client = useRestApiClient();

  const fetchUserLogs = async () => {
    let logs = [];
    try {
      const response = await client.get('/users/logs');
      const {
        data: { message: value }
      } = response;
      logs = value.sort((a, b) => {
        return parseInt(a.data, 10) - parseInt(b.data, 10);
      });
      setUserLastLog(logs[logs.length - 1]);
      setUserLogs(logs);
    } catch (error) {
      setUserLastLog({});
      setUserLogs([{ data: 0 }]);
    }
    return logs;
  };

  const addUserLog = async (payload) => {
    const response = await client.post('/users/logs', payload);
    const {
      data: { message: value }
    } = response;
    setUserLastLog(value);
    return value;
  };

  return {
    userLogs,
    userLastLog,
    fetchUserLogs,
    addUserLog
  };
};

export default useUserLog;
